<template>
  <div class="content-wrapper">
    <router-view />
  </div>
</template>

<style scoped>

.content-wrapper {
  max-width: 960px;
  margin: 0 auto;
  padding: 20px;
  box-sizing: border-box;
}

</style>
